import API from '../../services/api.svelte.js';
import { save } from '../finding/v2-service.js';

export const fetchFindings = async (resource = "v2/finding/", config = {}) => {
    return API.search(resource, config)
        .catch((e) => {
            throw new Error(e);
        })
        .then(pFindings => {
            return pFindings;
        })
};

export const findFinding = (id, config = {}) => {
    return API.find('v2/finding/', id, config)
};

export const saveFinding = (data, config = {}, is_upsert = false) => {
    return API.save("v2/finding", data, [], config, is_upsert);
};

export const fetchFindingsProperties = async (config = { filter: {} }) => {
    return API.search('v2/finding-property/', config);
}


export const fetchFindingsPropertiesCount = async (config = { filter: {} }) => {
    return API.search("v2/finding-property/count/", config);
}

export const fetchFindingsPropertiesCountByKind = async (config = { filter: {} }) => {
    return API.search("v2/finding-property/count_by_kind/", config);
}


export const labels = {
    good     : 'Buena',
    info     : 'Info',
    none     : 'Ninguna',
    low      : 'Baja',
    medium   : 'Media',
    high     : 'Alta',
    critical : 'Crítica',
};

export default {
    fetchFindings,
    findFinding,
    saveFinding,
    fetchFindingsProperties,
    fetchFindingsPropertiesCount,
    fetchFindingsPropertiesCountByKind,
    labels
}